import {
  CircularProgress,
  DialogActions,
  DialogTitle,
  Divider,
  Grid,
  Dialog,
  Button,
  DialogContent,
} from '@mui/material'
import AutoComplete from '../../../components/AutoComplete/AutoComplete'
import { useState } from 'react'
import { metodoPrograma } from '../../../components/api'

const ModalEmissaoExame = ({ data, close }) => {
  const [modeloProposta, setModeloProposta] = useState([])
  const [paciente, setPaciente] = useState([])
  const [loading, setLoading] = useState(false)

  const handleFalse = () => {
    close(false)
  }

  const emiteSolicitacaoExame = async () => {
    setLoading(true)
    const payload = {
      idAtendimento: data?.idAtendimento,
      idPaciente: paciente?.[0]?.[0],
      idModeloDocumento: modeloProposta?.[0]?.[0],
    }

    const resp = await metodoPrograma('solicitaExame', payload)
    if (resp.status) {
      window.open(resp.urlDocumentoAssinado)
      handleFalse()
    }
    setLoading(false)
  }

  return (
    <Dialog maxWidth="lg" fullWidth open={true} onClose={handleFalse}>
      <DialogTitle divider>Requisição de Exames</DialogTitle>
      <Divider />
      <DialogContent divider>
        <Grid container spacing={2}>
          <Grid item xs={12} md={212}>
            <AutoComplete
              inputLabelProps={{ shrink: true }}
              InputLabelProps={{ shrink: true }}
              metodo="buscaPacienteAtendimento"
              value={paciente}
              name="acPaciente"
              label="Paciente"
              fullWidth
              margin="dense"
              variant="outlined"
              size="small"
              searchParams={{ idAtendimento: data?.idAtendimento }}
              onChange={async (_, val) => {
                setPaciente(val)
              }}
            />
          </Grid>
          <Grid item xs={12} md={212}>
            <AutoComplete
              inputLabelProps={{ shrink: true }}
              InputLabelProps={{ shrink: true }}
              metodo="buscaModeloDocumento"
              value={modeloProposta}
              name="acTipoAtendimento"
              label="Modelo de Documento"
              fullWidth
              margin="dense"
              variant="outlined"
              size="small"
              onChange={async (_, val) => {
                setModeloProposta(val)
              }}
            />
          </Grid>
          <Grid item xs={12}></Grid>
        </Grid>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button fullWidth variant="contained" onClick={handleFalse}>
          fechar
        </Button>
        <Button
          fullWidth
          variant="contained"
          onClick={emiteSolicitacaoExame}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} /> : null}
        >
          Requisitar exames
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalEmissaoExame
